import { createSelector } from 'reselect';
import REDUCER_NAME from './reducer-name';
import tempSessionIdGetter from '~/utils/deviceId.js';

export const authenticationReducerSelector = state => state[REDUCER_NAME];
export const brandReducerSelector = state => state.brand;

export const selectFrom = state => state[REDUCER_NAME].from;

export const selectPostAuthLocation = state => state[REDUCER_NAME].postAuthLocation;

export const selectSelectedTab = state => state[REDUCER_NAME].selectedTab;

export const registrationTokenSelector = state => state[REDUCER_NAME].registrationToken;

export const selectVerificationRequired = state => state[REDUCER_NAME].verificationSmsRequired;

export const selectShowMojeID = state => state[REDUCER_NAME].showMojeID;

export const selectMojeIDStatus = state => state[REDUCER_NAME].mojeIDStatus;

export const selectCddnRegisterStatus = state => state[REDUCER_NAME].cddnRegisterStatus;

export const selectShowTransactionLinkFlow = state => state[REDUCER_NAME].showTransactionLinkFlow;

export const extendedVerificationSelector = state => state[REDUCER_NAME].showExtendedVerification;

export const personalDetailsConfirmationSelector = state => state[REDUCER_NAME].shouldShowPersonalDetailsConfirmation;

export const selectExtraPlayerDetails = state => state[REDUCER_NAME].details;

export const responsibleGamingSelector = state => state[REDUCER_NAME].showResponsibleGamingPage;

export const shouldShowDepositLimitPageSelector = state => state[REDUCER_NAME].shouldShowDepositLimitPage;

export const shouldShowSessionLimitPageSelector = state => state[REDUCER_NAME].shouldShowSessionLimitPage;

export const shouldShowBalanceLimitPageSelector = state => state[REDUCER_NAME].shouldShowBalanceLimitPage;

export const olderThanAgeThresholdSelector = state => state[REDUCER_NAME].olderThanAgeThreshold;

export const showDepositLimitsSelector = state => state[REDUCER_NAME].showDepositLimits;

export const depositLimitCountryCodeSelector = state => state[REDUCER_NAME].depositLimitCountryCode;

export const casinoAndSportsbookEnabledSelector = state => state[REDUCER_NAME].casinoAndSportsbookEnabled;

export const showMFASelector = state => state[REDUCER_NAME].mfaEnabled;

export const mfaDataSelector = state => state[REDUCER_NAME].mfaData;

export const showWelcomeScreenSelector = state => state[REDUCER_NAME].shouldShowWelcomePageDetails;

export const postAuthLocationSelector = state => state[REDUCER_NAME].postAuthLocation;

export const selectAuthLoading = state => state[REDUCER_NAME].loadingAuth;

export const showPhoneVerificationSelector = state => state[REDUCER_NAME].showPhoneVerification;

export const showTempAccountScreenSelector = state => state[REDUCER_NAME].showTempAccountScreen;

export const showTempAccountLoginSelector = state => state[REDUCER_NAME].showTempAccountLogin;

export const showPlayerDetailsPageSelector = state => state[REDUCER_NAME].showPlayerDetailsPage;

export const showSchufaVerificationSelector = state => state[REDUCER_NAME].showSchufaReverification;

export const shouldShowPrivacyPolicySelector = state => state[REDUCER_NAME].shouldShowPrivacyPolicyMessage;

export const requiresLoginOnLugasSelector = state => state[REDUCER_NAME].requiresLoginOnLugas;

export const loadCaptchaSelector = state => state[REDUCER_NAME].loadCaptcha;
export const loadSeonSelector = state => state[REDUCER_NAME].loadSeon;

export const captchaWhitelistSelector = state => state[REDUCER_NAME].captchaWhitelisted;
export const captchaStatusSelector = state => state[REDUCER_NAME].captchaStatus;

export const selectShouldShowMarketingConsent = state => state[REDUCER_NAME].shouldShowMarketingConsent;
export const selectPersistedValues = state => state[REDUCER_NAME]?.persistedValues;

export const shouldShowWagerAndTimeLimitPageSelector = state => state[REDUCER_NAME].shouldShowWagerAndTimeLimitPage;

// credentials selector
export const emailSelector = state => state[REDUCER_NAME].email;
const passwordSelector = state => state[REDUCER_NAME].password;
export const captchaTokenSelector = state => state[REDUCER_NAME].captchaToken;
const complianceTermsSelector = state => state[REDUCER_NAME].isComplianceTermsAccepted;

export const selectWelcomePageOpen = state => state[REDUCER_NAME].welcomePageOpen;
export const showWelcomePopupSelector = state => state[REDUCER_NAME].showWelcomePopup;
export const selectTemporaryPlayer = state => state[REDUCER_NAME].temporaryPlayer;

export const credentialsSelector = createSelector(
	emailSelector,
	passwordSelector,
	captchaTokenSelector,
	complianceTermsSelector,
	(email, password, captchaToken = '', isComplianceTermsAccepted = false) => {
		const deviceId = tempSessionIdGetter();
		return {
			email,
			password,
			captchaToken,
			isComplianceTermsAccepted,
			deviceId
		};
	}
);

// authentication selector
/* FIXME this vs the authenticationSelector */
export const selectAuthenticated = state => state[REDUCER_NAME].authenticated;
export const mustChangePwSelector = state => state[REDUCER_NAME].mustChangePw;
export const shouldShowComplianceMessageSelector = state => state[REDUCER_NAME].shouldShowComplianceMessage;
const shouldShowMarketingCommunicationSettingsSelector = state =>
	state[REDUCER_NAME].shouldShowMarketingCommunicationSettings;
export const selectdeviceSessionId = state => state[REDUCER_NAME].deviceSession;
export const authenticationSelector = createSelector(
	selectAuthenticated,
	mustChangePwSelector,
	shouldShowComplianceMessageSelector,
	shouldShowMarketingCommunicationSettingsSelector,
	(authenticated, mustChangePw, shouldShowComplianceMessage, shouldShowMarketingCommunicationSettings) => {
		if (
			typeof mustChangePw === 'undefined' &&
			typeof shouldShowComplianceMessage === 'undefined' &&
			typeof shouldShowMarketingCommunicationSettings === 'undefined'
		) {
			return authenticated;
		}

		return (
			authenticated && !mustChangePw && !shouldShowComplianceMessage && !shouldShowMarketingCommunicationSettings
		);
	}
);

// sessionCriteriaScreen selector
export const sessionCriteriaScreenSelector = createSelector(
	shouldShowComplianceMessageSelector,
	extendedVerificationSelector,
	showDepositLimitsSelector,
	showPhoneVerificationSelector,
	requiresLoginOnLugasSelector,
	showPlayerDetailsPageSelector,
	(
		shouldShowComplianceMessage,
		showExtendedVerification,
		showDepositLimits,
		showPhoneVerification,
		requiresLoginOnLugas,
		showPlayerDetailsPage
	) => {
		return (
			shouldShowComplianceMessage ||
			showExtendedVerification ||
			showDepositLimits ||
			showPhoneVerification ||
			requiresLoginOnLugas ||
			showPlayerDetailsPage
		);
	}
);

export const playerDetailsPageDataSelector = state => state[REDUCER_NAME].playerDetailsPageData;
export const familyNameSelector = state => state[REDUCER_NAME].familyName;
export const firstNameSelector = state => state[REDUCER_NAME].firstName;
export const lastNameSelector = state => state[REDUCER_NAME].lastName;
export const peselSelector = state => state[REDUCER_NAME].pesel;
export const birthdaySelector = state => state[REDUCER_NAME].birthday;

export const selectAuthMobileCountryCode = state => state[REDUCER_NAME].mobileCountryCode;
export const selectAuthMobileNumber = state => state[REDUCER_NAME].mobileNumber;
export const selectAuthCallingCode = state => state[REDUCER_NAME].callingCode;
export const selectAuthPhoneNumber = state => state[REDUCER_NAME].phoneNumber;
export const selectShouldShowPlayerUpdateMessage = state => state[REDUCER_NAME].shouldShowPlayerUpdateMessage;
